// Проверка ИНН по сумме цифр
export const validateInnBySum = (inn: string): boolean => {
  if (/[^0-9]/.test(inn)) {
    return false;
  }

  if ([10, 12].indexOf(inn.length) === -1) {
    return false;
  }

  const checkDigit = (innValue: string, coefficients: number[]) => {
    let n = 0;
    coefficients.forEach((value, i) => {
      n += value * Number(innValue[i]);
    });
    return (n % 11) % 10;
  };

  switch (inn.length) {
    case 10: {
      const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
      return n10 === parseInt(inn[9], 10);
    }
    case 12: {
      const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
      const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
      return n11 === parseInt(inn[10], 10) && n12 === parseInt(inn[11], 10);
    }
    default: {
      return false;
    }
  }
};
